import ADMIN_CONSOLE_ROUTE_CONTENTS from "../constants/AdminConsoleRouteContents";
import ADMIN_CONSOLE_ROUTES from "../constants/AdminConsoleRoutes";

export const SIDEBAR_SECTIONS_ID = {
  SETTINGS: "settings",
  ADMIN_TOOLS: "adminTools",
  DIRECTORY: "directory",
  CONTENT_SETTINGS: "contentSettings",
};

export const SIDEBAR_OPTIONS_ID = {
  ADMIN_CONSOLE: "admin-console",
  DETAILS: "adminTools",
  REPORTING: "reporting",
  CONTENT_ADVISORY: "content-advisory",
  CONTENT_RESTRICTION: "content-restriction",
  SCHOOLS: "schools",
  CLASS_ROOMS: "classrooms",
  FACULTY: "faculty",
  STUDENTS: "students",
  ADMIN_QUICK_START: "admin-quick-start",
  CONTENT_PROMOTION: "content-promotion",
};

export default [
  {
    id: SIDEBAR_SECTIONS_ID.ADMIN_TOOLS,
    title: "Admin Tools",
    options: [
      {
        id: SIDEBAR_OPTIONS_ID.ADMIN_CONSOLE,
        content: ADMIN_CONSOLE_ROUTE_CONTENTS.ADMIN_CONSOLE,
        ariaLabel: ADMIN_CONSOLE_ROUTE_CONTENTS.ADMIN_CONSOLE,
        title: ADMIN_CONSOLE_ROUTE_CONTENTS.ADMIN_CONSOLE,
        url: ADMIN_CONSOLE_ROUTES.ADMIN_CONSOLE,
      },
      {
        id: SIDEBAR_OPTIONS_ID.ADMIN_QUICK_START,
        content: ADMIN_CONSOLE_ROUTE_CONTENTS.ADMIN_QUICK_START,
        ariaLabel: ADMIN_CONSOLE_ROUTE_CONTENTS.ADMIN_QUICK_START,
        title: ADMIN_CONSOLE_ROUTE_CONTENTS.ADMIN_QUICK_START,
        url: ADMIN_CONSOLE_ROUTES.ADMIN_QUICK_START,
      },
      {
        id: SIDEBAR_OPTIONS_ID.REPORTING,
        content: ADMIN_CONSOLE_ROUTE_CONTENTS.REPORTING,
        ariaLabel: ADMIN_CONSOLE_ROUTE_CONTENTS.REPORTING,
        title: ADMIN_CONSOLE_ROUTE_CONTENTS.REPORTING,
        url: ADMIN_CONSOLE_ROUTES.REPORTING,
        isNew: false,
      },
      {
        id: SIDEBAR_OPTIONS_ID.CONTENT_ADVISORY,
        content: ADMIN_CONSOLE_ROUTE_CONTENTS.CONTENT_ADVISORY,
        ariaLabel: ADMIN_CONSOLE_ROUTE_CONTENTS.CONTENT_ADVISORY,
        title: ADMIN_CONSOLE_ROUTE_CONTENTS.CONTENT_ADVISORY,
        url: ADMIN_CONSOLE_ROUTES.CONTENT_ADVISORY,
        isNew: false,
      },
    ],
  },
  {
    id: SIDEBAR_SECTIONS_ID.CONTENT_SETTINGS,
    title: "Content settings",
    options: [
      {
        id: SIDEBAR_OPTIONS_ID.CONTENT_PROMOTION,
        content: ADMIN_CONSOLE_ROUTE_CONTENTS.CONTENT_PROMOTION,
        ariaLabel: ADMIN_CONSOLE_ROUTE_CONTENTS.CONTENT_PROMOTION,
        title: ADMIN_CONSOLE_ROUTE_CONTENTS.CONTENT_PROMOTION,
        url: ADMIN_CONSOLE_ROUTES.CONTENT_PROMOTION,
        isNew: false,
      },
      {
        id: SIDEBAR_OPTIONS_ID.CONTENT_RESTRICTION,
        content: ADMIN_CONSOLE_ROUTE_CONTENTS.CONTENT_RESTRICTION,
        ariaLabel: ADMIN_CONSOLE_ROUTE_CONTENTS.CONTENT_RESTRICTION,
        title: ADMIN_CONSOLE_ROUTE_CONTENTS.CONTENT_RESTRICTION,
        url: ADMIN_CONSOLE_ROUTES.CONTENT_RESTRICTION,
        isNew: false,
      },
    ],
  },
  {
    id: SIDEBAR_SECTIONS_ID.DIRECTORY,
    title: "Directory",
    options: [
      {
        id: SIDEBAR_OPTIONS_ID.SCHOOLS,
        content: ADMIN_CONSOLE_ROUTE_CONTENTS.SCHOOLS,
        ariaLabel: ADMIN_CONSOLE_ROUTE_CONTENTS.SCHOOLS,
        title: ADMIN_CONSOLE_ROUTE_CONTENTS.SCHOOLS,
        url: ADMIN_CONSOLE_ROUTES.SCHOOLS,
        isNew: false,
      },
      {
        id: SIDEBAR_OPTIONS_ID.CLASS_ROOMS,
        content: ADMIN_CONSOLE_ROUTE_CONTENTS.CLASS_ROOMS,
        ariaLabel: ADMIN_CONSOLE_ROUTE_CONTENTS.CLASS_ROOMS,
        title: ADMIN_CONSOLE_ROUTE_CONTENTS.CLASS_ROOMS,
        url: ADMIN_CONSOLE_ROUTES.CLASS_ROOMS,
        isNew: false,
      },
      {
        id: SIDEBAR_OPTIONS_ID.FACULTY,
        content: ADMIN_CONSOLE_ROUTE_CONTENTS.TEACHERS,
        ariaLabel: ADMIN_CONSOLE_ROUTE_CONTENTS.TEACHERS,
        title: ADMIN_CONSOLE_ROUTE_CONTENTS.TEACHERS,
        url: ADMIN_CONSOLE_ROUTES.TEACHERS,
        isNew: false,
      },
      {
        id: SIDEBAR_OPTIONS_ID.STUDENTS,
        content: ADMIN_CONSOLE_ROUTE_CONTENTS.STUDENTS,
        ariaLabel: ADMIN_CONSOLE_ROUTE_CONTENTS.STUDENTS,
        title: ADMIN_CONSOLE_ROUTE_CONTENTS.STUDENTS,
        url: ADMIN_CONSOLE_ROUTES.STUDENTS,
        isNew: false,
      },
    ],
  },
];
